const updateColopharaCartCounts = (count) => {
  if (typeof count !== 'number') return;
  document.querySelectorAll('[data-cp-cart-count]').forEach((element) => {
    element.textContent = String(count).padStart(2, '0');
  });
};

document.addEventListener('cart:update', async (event) => {
  const resourceCount = event.detail?.resource?.item_count;
  if (typeof resourceCount === 'number') {
    updateColopharaCartCounts(resourceCount);
    return;
  }

  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    updateColopharaCartCounts(cart.item_count);
  } catch (error) {
    console.warn('Colophara cart count could not be refreshed.', error);
  }
});

document.addEventListener('cart:update', (event) => {
  const productForm = event.target instanceof Element
    ? event.target.closest('[data-cp-redirect-to-cart]')
    : null;
  const isSuccessfulProductAdd =
    productForm &&
    event.detail?.data?.source === 'product-form-component' &&
    event.detail?.data?.didError !== true;

  if (!isSuccessfulProductAdd) return;

  const root = window.Shopify?.routes?.root || '/';
  window.location.assign(`${root}cart`);
});

document.addEventListener('shopify:section:load', () => {
  document.querySelectorAll('.cp-marquee__track').forEach((track) => {
    track.style.animation = 'none';
    window.requestAnimationFrame(() => track.style.removeProperty('animation'));
  });
});

const submitColopharaCart = (form) => {
  if (!form) return;
  form.classList.add('is-updating');
  form.requestSubmit();
};

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-cp-quantity-change]');
  if (!button) return;

  const line = button.closest('[data-cp-cart-line]');
  const input = line?.querySelector('[data-cp-quantity-input]');
  if (!input) return;

  const delta = Number(button.dataset.cpQuantityChange || 0);
  const currentValue = Number(input.value || 0);
  input.value = String(Math.max(0, currentValue + delta));
  submitColopharaCart(button.closest('form'));
});

document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-cp-quantity-input]')) return;
  const value = Math.max(0, Number(event.target.value || 0));
  event.target.value = String(value);
  submitColopharaCart(event.target.closest('form'));
});
